module.exports = __webpack_public_path__ + "img/news4-1.f664198a.png";